define("shared/utils/constants/status-page", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MaintenanceStatus = _exports.LaterComponentStatus = _exports.IncidentStatus = _exports.IncidentImpact = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  let LaterComponentStatus;
  _exports.LaterComponentStatus = LaterComponentStatus;

  (function (LaterComponentStatus) {
    LaterComponentStatus["Operational"] = "operational";
    LaterComponentStatus["UnderMaintenance"] = "under_maintenance";
    LaterComponentStatus["DegradedPerformance"] = "degraded_performance";
    LaterComponentStatus["PartialOutage"] = "partial_outage";
    LaterComponentStatus["MajorOutage"] = "major_outage";
    LaterComponentStatus["Unknown"] = "";
  })(LaterComponentStatus || (_exports.LaterComponentStatus = LaterComponentStatus = {}));

  let IncidentStatus;
  _exports.IncidentStatus = IncidentStatus;

  (function (IncidentStatus) {
    IncidentStatus["Identified"] = "identified";
    IncidentStatus["Investigating"] = "investigating";
    IncidentStatus["Monitoring"] = "monitoring";
    IncidentStatus["Postmortem"] = "postmortem";
    IncidentStatus["Resolved"] = "resolved";
  })(IncidentStatus || (_exports.IncidentStatus = IncidentStatus = {}));

  let MaintenanceStatus;
  _exports.MaintenanceStatus = MaintenanceStatus;

  (function (MaintenanceStatus) {
    MaintenanceStatus["Completed"] = "completed";
    MaintenanceStatus["InProgress"] = "in_progress";
    MaintenanceStatus["Scheduled"] = "scheduled";
    MaintenanceStatus["Verifying"] = "verifying";
  })(MaintenanceStatus || (_exports.MaintenanceStatus = MaintenanceStatus = {}));

  let IncidentImpact;
  _exports.IncidentImpact = IncidentImpact;

  (function (IncidentImpact) {
    IncidentImpact["Critical"] = "critical";
    IncidentImpact["Major"] = "major";
    IncidentImpact["Minor"] = "minor";
    IncidentImpact["None"] = "none";
  })(IncidentImpact || (_exports.IncidentImpact = IncidentImpact = {}));
});